module.exports = __webpack_public_path__ + "media/asx.a6332914.mp4";